// src/lib/auth.js
import axios from "axios";

const API_BASE = "https://gantasoft.in/rankridgecollege/dev/v1";

export const tokenKey = "rr_token";
export const userKey  = "rr_user";

export function getToken() { return localStorage.getItem(tokenKey) || ""; }
export function setSession(token, user) {
  localStorage.setItem(tokenKey, token);
  localStorage.setItem(userKey, JSON.stringify(user || null));
}
export function clearSession() {
  localStorage.removeItem(tokenKey);
  localStorage.removeItem(userKey);
}
export function getUser() {
  try { return JSON.parse(localStorage.getItem(userKey) || "null"); }
  catch { return null; }
}

export const api = axios.create({ baseURL: API_BASE });

// attach Bearer token
api.interceptors.request.use(cfg => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// handle 401
api.interceptors.response.use(
  res => res,
  err => {
    if (err?.response?.status === 401) {
      clearSession();
      // optional redirect:
      if (window.location.pathname !== "/login") window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);
